import { timelineItems } from '@/mocks/homeData';

const tagStyle: Record<string, string> = {
  accent: 'bg-accent-100 text-accent-800',
  default: 'bg-secondary-100 text-secondary-800',
};

export default function TimelineSection() {
  return (
    <section id="timeline" className="bg-background-100 border-y border-background-200">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-14 md:py-20">
        <div className="max-w-2xl">
          <p className="text-xs font-medium text-primary-700 tracking-wide flex items-center gap-2">
            <span className="w-6 h-px bg-primary-300"></span>
            网络踪迹时间线
          </p>
          <h2 className="mt-3 font-heading text-2xl md:text-3xl font-semibold text-foreground-950">
            一条动态快讯，拼出吃瓜捷克的网络轨迹
          </h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base leading-relaxed">
            从「评论区里会说话的网友」到被反复追问身份的创作者，按时间轴还原几个关键节点。
          </p>
        </div>

        <ol className="mt-10 md:mt-12 relative ml-2 md:ml-3 border-l border-background-300 space-y-2">
          {timelineItems.map((item, i) => (
            <li key={item.date} className="relative pl-6 md:pl-8 pb-2">
              <span className="absolute -left-[5px] top-2 w-2.5 h-2.5 rounded-full bg-background-50 border-2 border-accent-500"></span>
              <div className="bg-background-50 rounded-lg border border-background-200 p-4 md:p-5">
                <div className="flex flex-wrap items-center gap-2">
                  <span className="text-xs font-medium text-foreground-500 tabular-nums whitespace-nowrap">
                    {item.date}
                  </span>
                  <span
                    className={`inline-flex items-center px-2 py-0.5 rounded-full text-[11px] whitespace-nowrap ${
                      tagStyle[item.tagType ?? 'default']
                    }`}
                  >
                    {item.tag}
                  </span>
                  <span className="ml-auto text-[11px] text-foreground-300">#{String(i + 1).padStart(2, '0')}</span>
                </div>
                <h3 className="mt-2.5 text-sm md:text-base font-medium text-foreground-950">{item.title}</h3>
                <p className="mt-1.5 text-xs md:text-sm text-foreground-600 leading-relaxed max-w-3xl">{item.text}</p>
              </div>
            </li>
          ))}
        </ol>

        <p className="mt-6 text-xs text-foreground-400 flex items-center gap-1.5">
          <i className="ri-time-line" aria-hidden="true"></i>
          时间节点来自可查证的动态与公开考古，具体日期的精确度有限，请以本人账号为准。
        </p>
      </div>
    </section>
  );
}